import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../app/shared/shared.module';

import * as Services from './services/services';
import * as DaoProvider from './services/dao/daoProvider';
import { StatusService } from './services/status.service';
import { DeviceInfoService } from './services/device-info/device-info.service';
import { AffiliateStatusService } from './services/affiliate-status.service';
import { ArrayParsingUtils } from './services/array-parsing-utils';

// ATTENTION: Never import this module into a lazy loaded module. Only import into app module.
@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [],
  exports: [],
  providers: [
    // SERVICES
    Services.AuthService,
    Services.ApiHelper,
    Services.ApiInterceptorService,
    Services.AppMessagingService,
    Services.NumberFormatterService,
    Services.YouTubeValidationService,
    Services.DialogsService,
    Services.CharterBuyflowSessionService,
    Services.EnvironmentalMediaService,
    Services.ListYourBoatSessionService,
    Services.VesselRateCalculationService,
    Services.VanityUrlService,
    Services.BuyflowSortFilterService,
    Services.BuyflowSortFilterService,
    Services.MobileRequestBookingDialogService,
    Services.WaterBodyNavigationService,
    Services.ExternalScriptService,
    StatusService,
    DeviceInfoService,
    AffiliateStatusService,
    ArrayParsingUtils,
    // DAOs
    DaoProvider.provideMasterUserDAO(),
    DaoProvider.provideMasterRoleDAO(),
    DaoProvider.provideMasterPermissionDAO(),
    DaoProvider.provideMasterWaterBodyDAO(),
    DaoProvider.provideMasterUploadDAO(),
    DaoProvider.provideMasterCaptainDAO(),
    DaoProvider.provideMasterBookingDAO(),
    DaoProvider.provideMasterDiscountDAO(),
    DaoProvider.provideMasterVesselDAO(),
    DaoProvider.provideMasterVesselCaptainMapDAO(),
    DaoProvider.provideMasterServiceRecordDAO(),
    DaoProvider.provideMasterVesselImageDAO(),
    DaoProvider.provideMasterAddOnDAO(),
    DaoProvider.provideMasterCharterDAO(),
    DaoProvider.provideMasterPayoutDAO(),
    DaoProvider.provideMasterSubPayoutDAO(),
    DaoProvider.provideMasterPaystubDAO(),
    DaoProvider.provideMasterBoatOwnerDAO(),
    DaoProvider.provideMasterCrewMemberDAO(),
    DaoProvider.provideMasterPaymentDAO(),
    DaoProvider.provideMasterVesselRateDAO(),
    DaoProvider.provideMasterMooringLocationDAO(),
    DaoProvider.provideMasterReportDAO(),
    DaoProvider.provideMasterCustomerDAO(),
    DaoProvider.provideMasterCustomerReviewDAO(),
    DaoProvider.provideMasterCaptainManageDetailsDAO(),
    DaoProvider.provideMasterProductOfferingDAO(),
    DaoProvider.provideMasterCalendarPreferencesDAO(),
    DaoProvider.provideMasterCharterVesselAvailabilityDAO(),
    DaoProvider.provideMasterCharterPaymentDAO(),
    DaoProvider.provideMasterStripePaymentDAO(),
    DaoProvider.provideMasterVesselAvailabilityPreferencesDAO(),
    DaoProvider.provideMasterAffiliateDAO(),
    DaoProvider.provideMasterAbandonedBuyflowDAO(),
    DaoProvider.provideMasterLoggingDAO(),
    DaoProvider.provideMasterCharterAlternateTimeRequestsDAO(),
    DaoProvider.provideMasterOfferDAO(),
    DaoProvider.provideMasterMarketDAO(),
    DaoProvider.provideMasterNotificationDAO(),
    DaoProvider.provideMasterCaptainGigDAO(),
    DaoProvider.provideHubspotContactUpdateDAO(),
    DaoProvider.provideCharterNoteDAO(),
    DaoProvider.provideVesselSplitRateDAO(),
    DaoProvider.provideMasterVesselAvailabilityDAO(),
    DaoProvider.providePostsDAO(),
    DaoProvider.provideMasterCometChatDAO(),
  ],
})
export class CoreModule {}
